import { ref } from "vue";

import { v4 as uuidv4 } from "uuid";

interface Tooltip {
  x: number;
  y: number;
  text: string;
  id?: string;
  duration?: number;
}

const tooltips = ref<Tooltip[]>([]);

function pushTooltip(tooltip: Tooltip) {
  tooltip.id = uuidv4();
  tooltips.value.push(tooltip);
  setTimeout(() => {
    tooltips.value = tooltips.value.filter((e) => e.id !== tooltip.id);
    // Tooltips without a set duration will default to 1 second.
  }, tooltip.duration || 1000);
}

export function useTooltips() {
  return { tooltips, pushTooltip };
}
